import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b174a44"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title flex align-center justify-between"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "加密狗申请详情", -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "margin-bottom": "15px"
  }
}, "加密狗用户信息", -1));
const _hoisted_5 = {
  class: "line"
};
const _hoisted_6 = {
  class: "line-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "租户名称：", -1));
const _hoisted_8 = {
  class: "line"
};
const _hoisted_9 = {
  class: "line-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "诊所名称：", -1));
const _hoisted_11 = {
  class: "line-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加密狗编号：", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "margin-bottom": "15px"
  }
}, "加密狗应用授权信息", -1));
const _hoisted_14 = {
  class: "flex"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-title"
}, "当前使用", -1));
const _hoisted_17 = {
  class: "line"
};
const _hoisted_18 = {
  class: "line-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权版本：", -1));
const _hoisted_20 = {
  class: "line"
};
const _hoisted_21 = {
  class: "line-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务时间：", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin": "0 30px"
  }
}, "至", -1));
const _hoisted_24 = {
  class: "line"
};
const _hoisted_25 = {
  class: "line-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最后续费时间：", -1));
const _hoisted_27 = {
  class: "line"
};
const _hoisted_28 = {
  class: "line-item"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "版本状态：", -1));
const _hoisted_30 = {
  class: "line"
};
const _hoisted_31 = {
  class: "line-item"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权客户端数量：", -1));
const _hoisted_33 = {
  class: "line"
};
const _hoisted_34 = {
  class: "line-item"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "医保编码：", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-title"
}, "当前申请", -1));
const _hoisted_37 = {
  class: "line"
};
const _hoisted_38 = {
  class: "line-item"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权版本：", -1));
const _hoisted_40 = {
  class: "line"
};
const _hoisted_41 = {
  class: "line-item"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务时间：", -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin": "0 30px"
  }
}, "至", -1));
const _hoisted_44 = {
  class: "line"
};
const _hoisted_45 = {
  class: "line-item"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最后续费时间：", -1));
const _hoisted_47 = {
  class: "line"
};
const _hoisted_48 = {
  class: "line-item"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "版本状态：", -1));
const _hoisted_50 = {
  class: "line"
};
const _hoisted_51 = {
  class: "line-item"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权客户端数量：", -1));
const _hoisted_53 = {
  class: "line"
};
const _hoisted_54 = {
  class: "line-item"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "医保编码：", -1));
const _hoisted_56 = {
  class: "title flex align-center justify-between"
};
const _hoisted_57 = {
  class: "title"
};
const _hoisted_58 = {
  key: 0
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "margin-bottom": "15px"
  }
}, "应用授权信息", -1));
const _hoisted_60 = {
  class: "line"
};
const _hoisted_61 = {
  class: "line-item"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权版本：", -1));
const _hoisted_63 = {
  class: "line"
};
const _hoisted_64 = {
  class: "line-item"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权时间：", -1));
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin": "0 30px"
  }
}, "至", -1));
const _hoisted_67 = {
  class: "line"
};
const _hoisted_68 = {
  class: "line-item"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "版本状态：", -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "历史审核进度", -1));
import { ref, onMounted, computed, h } from 'vue';
import { useRoute } from 'vue-router';
import { getApprovalProcess, findDongleApprovalPage, findAuthPlatformApprovalPage, updateDongleApproval, updateApplicationApproval, rejectDongleApproval, rejectAuthPlatformApproval
// findDongleUserModuleByHistoryId
} from '@/api/approval';
import ApprovalStepVue from './components/ApprovalStep';
import { ElMessageBox, ElMessage, ElInput } from 'element-plus';
import { useStore } from 'vuex';
import { findDongleUserModuleByHistoryId } from '@/api/dongle';
import { applicationStatus } from './config';
export default {
  __name: 'info',
  setup(__props) {
    const route = useRoute();
    const approvalItemId = ref(route.params.id);
    const approvalProcess = ref({});
    const historyApprovals = ref([]);
    const approvalType = ref(0);
    // const dongleUserName = ref('')
    // const dongleUserModuleNmae = ref('')

    // const authModule = ref('')
    // const tenantName = ref('')
    // const clinicName = ref('')
    const id = ref('');
    const active = ref(0);
    const _getApprovalProcess = async () => {
      active.value = 1;
      const res = await getApprovalProcess({
        approvalItemId: approvalItemId.value
      });
      console.log('31');
      approvalProcess.value = res[0];
      historyApprovals.value = res === null || res === void 0 ? void 0 : res.slice(1);
      historyApprovals.value = historyApprovals.value.map(item => {
        item.approvalList.unshift({
          auditorName: `${item.name}发起申请`,
          approvalTime: item.createTime
        });
        return {
          ...item
        };
      });
      approvalType.value = approvalProcess.value.approvalList.length ? approvalProcess.value.approvalList[0].approvalType : 0;
      id.value = approvalProcess.value.approvalList.length ? approvalProcess.value.approvalList[0].id : '';
      approvalProcess.value.approvalList.unshift({
        auditorName: `${res[0].name}发起申请`,
        approvalTime: res[0].createTime
      });
      if (approvalType.value === 2) {
        // const approvalListLength = approvalProcess.value.approvalList.length
        // if (!approvalListLength) return
        // const desc = approvalProcess.value.approvalList[0].approvalItemName?.split('_')
        // console.log(desc)
        // if (desc.length > 2) {
        //   // 有诊所名
        //   authModule.value = desc[2]
        //   tenantName.value = desc[0]
        //   clinicName.value = desc[1]
        // } else {
        //   // 无诊所名
        //   authModule.value = desc[1]
        //   tenantName.value = desc[0]
        // }
      } else {
        // dongleUserName.value = approvalProcess.value.approvalList.length
        //   ? approvalProcess.value.approvalList[0].approvalItemName?.split('_')[0]
        //   : ' '
        // dongleUserModuleNmae.value = approvalProcess.value.approvalList.length
        //   ? approvalProcess.value.approvalList[0].approvalItemName?.split('_')[1]
        //   : ' '
      }
      const activeIndex = approvalProcess.value.approvalList.findIndex(item => item.approvalStatus && item.approvalStatus === 1);

      // eslint-disable-next-line
      if (activeIndex == -1) {
        // 全部审批
        active.value += approvalProcess.value.approvalList.length - 1;

        // eslint-disable-next-line
      } else if (activeIndex == 0) {
        // 第一个就没审批
        active.value += 1;
      } else if (activeIndex > 0) {
        // 找到第一个未审批
        active.value = activeIndex;
      }
    };
    const approvalInfo = ref({});
    const loadApprovalData = async () => {
      if (approvalType.value === 1) {
        // his审批
        const res = await findDongleApprovalPage({
          id: id.value
        });
        approvalInfo.value = res.records[0];
      } else {
        // web审批
        const res = await findAuthPlatformApprovalPage({
          id: id.value
        });
        approvalInfo.value = res.records[0];
      }
    };
    const loading = ref(false);
    onMounted(async () => {
      loading.value = true;
      await _getApprovalProcess();
      await loadApprovalData();
      await _findDongleUserModuleByHistoryId();
      loading.value = false;
    });
    const store = useStore();
    const isApprovalBtnVisible = computed(() => {
      var _approvalProcess$valu;
      const approvalItemIndex = (_approvalProcess$valu = approvalProcess.value) === null || _approvalProcess$valu === void 0 || (_approvalProcess$valu = _approvalProcess$valu.approvalList) === null || _approvalProcess$valu === void 0 ? void 0 : _approvalProcess$valu.findIndex(item => item.auditorId === store.getters.userInfo.sysUser.id);
      if (approvalItemIndex === -1 || approvalItemIndex === undefined) return false;
      return (approvalInfo.value['applyStatus'] === 1 || approvalInfo.value['applyStatus'] === 3) && approvalInfo.value['finalStatus'] === 1 && approvalInfo.value['approvalStatus'] === 1;
    });
    const handleConfirm = async () => {
      ElMessageBox.confirm('是否确认审核该条记录', '温馨提示!', {}).then(async () => {
        if (approvalType.value === 1) {
          // his
          await updateDongleApproval({
            id: approvalInfo.value.id,
            approvalItemId: approvalInfo.value.approvalItemId,
            approvalStatus: 2,
            approvalVersion: approvalInfo.value.approvalVersion
          });
        } else {
          // web
          await updateApplicationApproval({
            id: approvalInfo.value.id,
            approvalItemId: approvalInfo.value.approvalItemId,
            approvalStatus: 2,
            approvalVersion: approvalInfo.value.approvalVersion
          });
        }
        await _getApprovalProcess();
        loadApprovalData();
        ElMessage.success('审批成功');
      });
    };
    const handleReject = async () => {
      const value = ref('');
      ElMessageBox({
        title: '温馨提示!',
        showCancelButton: true,
        message: () => h(ElInput, {
          modelValue: value.value,
          placeholder: '请输入拒绝原因',
          type: 'textarea',
          autosize: {
            minRows: 5
          },
          'onUpdate:modelValue': val => {
            value.value = val;
          }
        })
      }).then(async () => {
        if (approvalType.value === 1) {
          // his
          await rejectDongleApproval({
            id: approvalInfo.value.id,
            approvalItemId: approvalInfo.value.approvalItemId,
            approvalStatus: 3,
            remark: value.value,
            approvalVersion: approvalInfo.value.approvalVersion
          });
        } else {
          // web
          await rejectAuthPlatformApproval({
            id: approvalInfo.value.id,
            approvalItemId: approvalInfo.value.approvalItemId,
            approvalStatus: 3,
            remark: value.value,
            approvalVersion: approvalInfo.value.approvalVersion
          });
        }
        await _getApprovalProcess();
        loadApprovalData();
        ElMessage.success('拒绝成功');
      });
    };
    const dongHistoryModule = ref({});
    const _findDongleUserModuleByHistoryId = async () => {
      const res = await findDongleUserModuleByHistoryId({
        historyId: approvalInfo.value.historyId
      });
      dongHistoryModule.value = res;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [approvalType.value === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_card, {
          shadow: "never",
          style: {
            "border": "none",
            "margin-bottom": "20px"
          }
        }, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, isApprovalBtnVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
            class: "button",
            type: "primary",
            onClick: handleConfirm
          }, {
            default: _withCtx(() => [_createTextVNode("同意")]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "button",
            type: "danger",
            onClick: handleReject
          }, {
            default: _withCtx(() => [_createTextVNode("拒绝")]),
            _: 1
          })])) : _createCommentVNode("", true)])]),
          default: _withCtx(() => {
            var _approvalInfo$value, _approvalInfo$value2, _approvalInfo$value3;
            return [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createTextVNode(" " + _toDisplayString((_approvalInfo$value = approvalInfo.value) === null || _approvalInfo$value === void 0 ? void 0 : _approvalInfo$value.tenantName), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createTextVNode(" " + _toDisplayString((_approvalInfo$value2 = approvalInfo.value) === null || _approvalInfo$value2 === void 0 ? void 0 : _approvalInfo$value2.clinicName), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createTextVNode(" " + _toDisplayString((_approvalInfo$value3 = approvalInfo.value) === null || _approvalInfo$value3 === void 0 ? void 0 : _approvalInfo$value3.name), 1)])])];
          }),
          _: 1
        }), _createVNode(_component_el_card, {
          shadow: "never",
          style: {
            "border": "none",
            "margin-bottom": "20px"
          }
        }, {
          default: _withCtx(() => {
            var _dongHistoryModule$va, _dongHistoryModule$va2, _dongHistoryModule$va3, _dongHistoryModule$va4, _dongHistoryModule$va5, _dongHistoryModule$va6, _dongHistoryModule$va7, _approvalInfo$value4, _approvalInfo$value5, _approvalInfo$value6, _approvalInfo$value7, _approvalInfo$value8, _approvalInfo$value9, _approvalInfo$value10;
            return [_hoisted_13, _createElementVNode("div", _hoisted_14, [approvalInfo.value.historyId ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createTextVNode(" " + _toDisplayString((_dongHistoryModule$va = dongHistoryModule.value) === null || _dongHistoryModule$va === void 0 ? void 0 : _dongHistoryModule$va.moduleConfigName), 1)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createTextVNode(" " + _toDisplayString((_dongHistoryModule$va2 = dongHistoryModule.value) === null || _dongHistoryModule$va2 === void 0 ? void 0 : _dongHistoryModule$va2.beginTime) + " ", 1), _hoisted_23, _createTextVNode(" " + _toDisplayString((_dongHistoryModule$va3 = dongHistoryModule.value) === null || _dongHistoryModule$va3 === void 0 ? void 0 : _dongHistoryModule$va3.endTime), 1)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createTextVNode(_toDisplayString((_dongHistoryModule$va4 = dongHistoryModule.value) === null || _dongHistoryModule$va4 === void 0 ? void 0 : _dongHistoryModule$va4.modifyTime), 1)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createTextVNode(_toDisplayString(((_dongHistoryModule$va5 = dongHistoryModule.value) === null || _dongHistoryModule$va5 === void 0 ? void 0 : _dongHistoryModule$va5.applyStatus) === 1 ? '使用中' : '停用'), 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createTextVNode(_toDisplayString((_dongHistoryModule$va6 = dongHistoryModule.value) === null || _dongHistoryModule$va6 === void 0 ? void 0 : _dongHistoryModule$va6.clientNumber), 1)])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createTextVNode(" " + _toDisplayString((_dongHistoryModule$va7 = dongHistoryModule.value) === null || _dongHistoryModule$va7 === void 0 ? void 0 : _dongHistoryModule$va7.ybCode), 1)])])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createTextVNode(" " + _toDisplayString((_approvalInfo$value4 = approvalInfo.value) === null || _approvalInfo$value4 === void 0 ? void 0 : _approvalInfo$value4.moduleConfigName), 1)])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createTextVNode(" " + _toDisplayString((_approvalInfo$value5 = approvalInfo.value) === null || _approvalInfo$value5 === void 0 ? void 0 : _approvalInfo$value5.beginTime) + " ", 1), _hoisted_43, _createTextVNode(" " + _toDisplayString((_approvalInfo$value6 = approvalInfo.value) === null || _approvalInfo$value6 === void 0 ? void 0 : _approvalInfo$value6.endTime), 1)])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_hoisted_46, _createTextVNode(_toDisplayString((_approvalInfo$value7 = approvalInfo.value) === null || _approvalInfo$value7 === void 0 ? void 0 : _approvalInfo$value7.modifyTime), 1)])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_hoisted_49, _createTextVNode(_toDisplayString(_unref(applicationStatus)[(_approvalInfo$value8 = approvalInfo.value) === null || _approvalInfo$value8 === void 0 ? void 0 : _approvalInfo$value8.applyStatus]), 1)])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_hoisted_52, _createTextVNode(_toDisplayString((_approvalInfo$value9 = approvalInfo.value) === null || _approvalInfo$value9 === void 0 ? void 0 : _approvalInfo$value9.clientNumber), 1)])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createTextVNode(" " + _toDisplayString((_approvalInfo$value10 = approvalInfo.value) === null || _approvalInfo$value10 === void 0 ? void 0 : _approvalInfo$value10.ybCode), 1)])])])])];
          }),
          _: 1
        })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_card, {
          shadow: "never",
          style: {
            "border": "none",
            "margin-bottom": "20px"
          }
        }, {
          header: _withCtx(() => {
            var _approvalInfo$value11;
            return [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(((_approvalInfo$value11 = approvalInfo.value) === null || _approvalInfo$value11 === void 0 ? void 0 : _approvalInfo$value11.type) === 1 ? '小程序' : 'web应用') + "申请详情", 1), isApprovalBtnVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createVNode(_component_el_button, {
              class: "button",
              type: "primary",
              onClick: handleConfirm
            }, {
              default: _withCtx(() => [_createTextVNode("同意")]),
              _: 1
            }), _createVNode(_component_el_button, {
              class: "button",
              type: "danger",
              onClick: handleReject
            }, {
              default: _withCtx(() => [_createTextVNode("拒绝")]),
              _: 1
            })])) : _createCommentVNode("", true)])];
          }),
          _: 1
        }), _createVNode(_component_el_card, {
          shadow: "never",
          style: {
            "border": "none",
            "margin-bottom": "20px"
          }
        }, {
          default: _withCtx(() => {
            var _approvalInfo$value12, _approvalInfo$value13, _approvalInfo$value14, _approvalInfo$value15;
            return [_hoisted_59, _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_hoisted_62, _createTextVNode(" " + _toDisplayString((_approvalInfo$value12 = approvalInfo.value) === null || _approvalInfo$value12 === void 0 ? void 0 : _approvalInfo$value12.moduleConfigName), 1)])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_hoisted_65, _createTextVNode(" " + _toDisplayString((_approvalInfo$value13 = approvalInfo.value) === null || _approvalInfo$value13 === void 0 ? void 0 : _approvalInfo$value13.beginTime) + " ", 1), _hoisted_66, _createTextVNode(" " + _toDisplayString((_approvalInfo$value14 = approvalInfo.value) === null || _approvalInfo$value14 === void 0 ? void 0 : _approvalInfo$value14.endTime), 1)])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_hoisted_69, _createTextVNode(" " + _toDisplayString(_unref(applicationStatus)[(_approvalInfo$value15 = approvalInfo.value) === null || _approvalInfo$value15 === void 0 ? void 0 : _approvalInfo$value15.applyStatus]), 1)])])];
          }),
          _: 1
        })], 64)), _createVNode(_unref(ApprovalStepVue), {
          approvalProcess: approvalProcess.value,
          active: active.value
        }, null, 8, ["approvalProcess", "active"]), historyApprovals.value.length ? (_openBlock(), _createBlock(_component_el_card, {
          key: 2,
          shadow: "never",
          style: {
            "border": "none"
          }
        }, {
          header: _withCtx(() => [_hoisted_70]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyApprovals.value, (item, index) => {
            var _item$approvalList;
            return _openBlock(), _createBlock(_unref(ApprovalStepVue), {
              key: index,
              approvalProcess: item,
              active: (_item$approvalList = item.approvalList) === null || _item$approvalList === void 0 ? void 0 : _item$approvalList.length
            }, null, 8, ["approvalProcess", "active"]);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })), [[_directive_loading, loading.value]]);
    };
  }
};